<template>
  <div>
    <mu-content-block v-if="isLoading" style="text-align: center">
      <mu-circular-progress :size="32"></mu-circular-progress>
      <br/>
      <span v-text="$t('message.loadingText')"></span>
    </mu-content-block>
    <div id="lifeCategoryView" class="content" v-if="!isLoading">
      <mu-flexbox class="row" :gutter="16" v-for="chunks, index in chunkedItems" :key="'chunk-' + index">
        <mu-flexbox-item class="post" v-for="post, index in chunks" :key="'post-' + index">
            <mu-card>
              <router-link :to="{ name: 'LifeStyleArticle', params: { permalink: post.post_slug }}">
                <mu-card-media class="imgHolder">
                  <div class="img" v-bind:style="{ 'background-image':'url('+ post.post_image +')' }"></div>
                </mu-card-media>
                <div class="overlay">
                  <mu-flexbox justify="flex-end" align="align" class="item">
                    <h3 class="largeTitle">
                      <span v-if="isHcpView" v-once>{{ truncate(post.post_title) }}</span>
                      <span v-if="!isHcpView">{{post.post_title}}</span>
                    </h3>
                    <mu-card-text class="desc">
                      <div class="extract">
                        <div>{{post.post_excerpt}}
                          <!--<router-link class="blueTitle" :to="{ name: 'LifeStyleArticle', params: { permalink: post.post_slug }}" replace>Read more</router-link>-->
                        </div>
                      </div>
                    </mu-card-text>
                  </mu-flexbox>
                </div>
              </router-link>
              <div class="stats-bar">
                <div class="stat favourites">
                  <mu-icon-button @click.native="favouritePost(post.post_id)"
                                  :icon="post.post_favourited  ? 'favorite' : 'favorite_border'"
                                  :disabled="userId === false"/>
                  <span class="amount" v-text="post.post_favourites"></span>
                </div>
              </div>
            </mu-card>
        </mu-flexbox-item>
      </mu-flexbox>
      <mu-raised-button type="button" v-if="!isPostsFinished" full-width :disabled="isAppending || isLoading"  @click="loadCatPosts(getPostParams, termId, 'append')">{{isAppending ? 'Loading...': 'Load more'}}</mu-raised-button>
      <mu-content-block align="center" v-if="!isLoading && isAppending">
        <mu-circular-progress :size="32"></mu-circular-progress>
      </mu-content-block>
    </div>
  </div>
</template>

<script>

  import TitleManager from '../../../helpers/TitleManager'
  import LifeStyleApi from '../../../api/LifeStyle/index';

  import LifeMixin from '../../../mixins/Localization/Life';
  import HCPMixin from '../../../mixins/HCPMixin';
  import {findIconDefinition} from "@fortawesome/fontawesome-svg-core";

  export default {
    mixins: [
      LifeMixin,
      HCPMixin
    ],
    name: 'life-category',
    watch: {
      // Only reload when the category itself changes. Watching the whole $route
      // object also reacted to incidental route mutations (e.g. a same-route
      // replace from the payment-wall guard, or query/hash changes), which
      // re-ran initMounted() on top of the one in mounted() — fetching and
      // rendering the category twice. initMounted() already resets paging/state.
      "$route.params.slug": function (slug) {
        let self = this;
        if (!slug) return;
        self.initMounted();
      }
    },
    data () {
      return {
        posts: [],
        category: {},
        getPostParams: {
          page: 1,
          per_page: 10,
          size: 'medium-400',
        },
        slug: "",
        isLoading: true,
        isPostsFinished: false,
        isAppending: false,
        termId: null
      }
    },
    methods: {
      findIconDefinition,
      truncate(string) {
        return _.truncate(string, {
          'length' : 77
        });
      },
      loadCatPosts(params, term_id, mode) {
        let self = this;

        if(mode !== 'append') {
          this.isLoading = true;
        }

        this.isAppending = true;
        LifeStyleApi.getCategoryPosts(params.page, params.per_page, term_id, params.size).then((response) => {
          self.isLoading = false;
          let callback = response.data;
          if (callback.length) {
            if (self.getPostParams.page === 1) {
              self.posts = callback;
            } else {
              self.posts.push.apply(self.posts, callback);
              self.isAppending = false;
              //self.calcPostHeight();
            }
          } else {
            self.isPostsFinished = true;
            self.isAppending = false;
          }
        });
        self.getPostParams.page += 1;
      },
      loadCat(slug) {
        let self = this;
        self.category = {};
        self.posts = [];
        self.setTitle(self.$t('message.loadingText'));
        LifeStyleApi.getCategory(slug).then((response) => {
          self.getPostParams.page = 1;
          self.posts = [];
          self.category = response.data;
          self.setTitle(self.localizeLifeCat(self.category.term_id) || self.category.name);
          window.document.title = ( self.localizeLifeCat(self.category.term_id) || self.category.name ) + ' | LifeStyle';
          if(self.isHcpUser) {
            TitleManager.replaceTitle(self.localizeLifeCat(self.category.term_id) || self.category.name);
          }
          self.termId = response.data.term_id;
          self.loadCatPosts(self.getPostParams, response.data.term_id);
          self.initScroll();
        });
      },
      setTitle(title) {
        TitleManager.setTitle(title);
      },
      favouritePost(post_id) {
        let self = this,
          post = _.find(self.posts, ['post_id', post_id]);
        LifeStyleApi.favouritePost({
          post_id: post_id
        }).then((res) => {
          const callback = res.data;
          if (callback.fav_status) {
            post.post_favourited = true;
            post.post_favourites += 1;
          } else {
            post.post_favourited = false;
            post.post_favourites -= 1;
          }
        });
      },
      goTo(slug) {
        let self = this;
        self.$router.push({name: 'LifeStyleArticle', params: {permalink: slug}})
      },
      calcPostHeight() {
        let self = this;
        $(function () {
          calcEachPost();
          $(window).resize(function () {
            calcEachPost();
          });
          function calcEachPost() {
            $('.post').each(function () {
              const post = $(this),
                contentHeight = post.find('.desc').outerHeight();
              post.find('.overlay').css({
                'bottom': '-' + contentHeight + 'px'
              });
            });
          }
        });
      },
      initScroll() {
        const self = this;
        const el = self.$route.meta.id;

        function debounce(func, wait) {
          let timeout;
          return function(...args) {
            const context = this;
            clearTimeout(timeout);
            timeout = setTimeout(() => func.apply(context, args), wait);
          };
        }

        function handleScroll() {
          const container = document.getElementById(el);
          // The listener can fire after navigating away (the main-content id
          // changes per route), at which point getElementById returns null.
          if (!container) {
            return;
          }
          if (container.scrollTop + container.clientHeight >= (container.scrollHeight)) {
            if (!self.isPostsFinished && !self.isLoading) {
              self.isLoading = true;
              self.loadCatPosts(self.getPostParams, self.category.term_id);
              self.isLoading = false;
              self.isAppending = true;
            }
          }
        }

        const debouncedHandleScroll = debounce(handleScroll, 100);
        const container = document.getElementById(el);

        if (container) {
          // Remove any previous listener before re-binding (initScroll can run
          // again on re-entry) and keep refs so we can clean up on destroy.
          if (self._scrollContainer && self._scrollHandler) {
            self._scrollContainer.removeEventListener('scroll', self._scrollHandler);
          }
          self._scrollContainer = container;
          self._scrollHandler = debouncedHandleScroll;
          container.addEventListener('scroll', debouncedHandleScroll);
        }
      },
      initMounted() {
        let self = this, el = self.$route.meta.id;
        self.slug = self.$route.params.slug;
        self.posts = [];
        self.category = {};
        self.getPostParams.page = 1;
        self.isLoading = true;
        self.isPostsFinished = false;
        self.isAppending = false;
        self.loadCat(self.slug);
      }
    },
    computed: {
      chunkedItems () {
        let self = this;
        return _.chunk(_.toArray(self.posts), 2);
      },
      userId() {
        let self = this;
        if (_.has(self.$store.state.user, 'scope')) {
          return self.$store.state.user.scope.user_id;
        }
        return false;
      }
    },
    mounted () {
      let self = this;
      self.initMounted();
    },
    beforeDestroy() {
      let self = this;
      if (self._scrollContainer && self._scrollHandler) {
        self._scrollContainer.removeEventListener('scroll', self._scrollHandler);
        self._scrollContainer = null;
        self._scrollHandler = null;
      }
    },

  }

</script>
<style lang="less">
  @import "./life-category.less";
</style>



// WEBPACK FOOTER //
// LifeCategory.vue?f9b978a2